/**
 * Tasks Kanban Configuration
 * 
 * Configuration for the Tasks kanban board using the global Kanban component.
 */

import { KanbanConfig } from '../types';
import { Task } from 'shared/types/task';
import { 
  taskPhaseColumns, 
  getColumnForPhase, 
  type FrontendColumnId 
} from 'screens/tasks/taskPhaseConfig';

/**
 * Tasks Kanban Configuration
 * 
 * This config defines how the Tasks kanban should look and behave:
 * - Uses phase columns from taskPhaseConfig
 * - Shows count per column
 * - Shows plus button per column
 * - Custom grid layout for tasks
 */
export const tasksKanbanConfig: KanbanConfig<Task, FrontendColumnId> = {
  // Column definitions from existing taskPhaseConfig
  columns: taskPhaseColumns,
  
  // Get the column ID for a task based on its phase
  getItemStatus: (task: Task) => getColumnForPhase(task.phase),
  
  // Show count badge per column
  showCount: true,
  
  // Show plus icon per column to add tasks
  showAddButton: true,
  
  // Empty state configuration
  emptyState: {
    message: 'Geen taken',
  },
  
  // Columns are not scrollable (they stretch to full height automatically)
  scrollableColumns: true,
};

